const { REACT_APP_CLIENT_BASE_URL } = process.env

class NaturalPersonAccount {
    constructor(data = {}) {
      this.id = data._id || null
      this.type = data._type || 'natural'
      this.email = data.email || ''
      this.password = data.password || null
      this.passwordConfirmation = data.passwordConfirmation || null
      this.personalMobileNumber = data.personalMobileNumber || ''
      this.personalTelephoneNumber = data.personalTelephoneNumber || ''
      this.businessDescription = data.businessDescription || ''
      this.businessTarget = data.businessTarget || ''
      this.addressZipcode = data.addressZipcode || ''
      this.addressUF = data.addressUF || ''
      this.addressCity = data.addressCity || ''
      this.addressStreet = data.addressStreet || ''
      this.addressNeighborhood = data.addressNeighborhood || ''
      this.addressNumber = data.addressNumber || ''
      this.addressComplement = data.addressComplement || ''
      this.clientURL = REACT_APP_CLIENT_BASE_URL
    }
  }
  
  export default NaturalPersonAccount
  